"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = clone;

var _isObject = _interopRequireDefault(require("./isObject.js"));

var _isArray = _interopRequireDefault(require("./isArray.js"));

var _extend = _interopRequireDefault(require("./extend.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Create a (shallow-cloned) duplicate of an object.
function clone(obj) {
  if (!(0, _isObject.default)(obj)) return obj;
  return (0, _isArray.default)(obj) ? obj.slice() : (0, _extend.default)({}, obj);
}